(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hippie-wholesale"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hs-rep-picker'))customElements.define('hs-rep-picker',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;this.dataset.ready='true';
    const select=this.querySelector('select'),input=this.querySelector('input'),label=this.querySelector('label'),enhanced=this.querySelector('.hs-rep-picker__enhanced'),menu=this.querySelector('.hs-rep-picker__menu'),list=this.querySelector('[role=listbox]'),toggle=this.querySelector('button'),empty=this.querySelector('.hs-rep-picker__empty');
    if(!select||!input||!list)return;
    const options=Array.from(select.options).map(o=>({value:o.value,label:o.textContent}));let visible=[],active=-1,query='';
    select.hidden=true;enhanced.hidden=false;label.htmlFor=input.id;input.value=select.options[select.selectedIndex].textContent;
    const close=()=>{menu.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');active=-1;};
    const activate=index=>{active=index;Array.from(list.children).forEach((node,i)=>node.classList.toggle('is-active',i===index));const node=list.children[index];if(node){input.setAttribute('aria-activedescendant',node.id);node.scrollIntoView({block:'nearest'});}else input.removeAttribute('aria-activedescendant');};
    const choose=option=>{select.value=option.value;input.value=option.label;input.setCustomValidity('');query='';select.dispatchEvent(new Event('change',{bubbles:true}));close();};
    const render=()=>{const term=query.trim().toLocaleLowerCase();visible=options.filter((o,i)=>i===0||o.label.toLocaleLowerCase().includes(term));list.replaceChildren();visible.forEach((o,i)=>{const node=document.createElement('div');node.id=list.id+'-'+i;node.setAttribute('role','option');node.setAttribute('aria-selected',String(o.value===select.value));node.textContent=o.label;node.addEventListener('pointerdown',e=>e.preventDefault());node.addEventListener('click',()=>choose(o));list.append(node);});empty.textContent=this.dataset.empty;empty.hidden=!term||visible.length>1;menu.hidden=false;input.setAttribute('aria-expanded','true');active=-1;input.removeAttribute('aria-activedescendant');};
    input.addEventListener('focus',()=>{query='';render();input.select();});input.addEventListener('input',()=>{query=input.value;input.setCustomValidity(this.dataset.invalid);render();});
    input.addEventListener('keydown',e=>{if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();if(menu.hidden)render();activate(e.key==='ArrowDown'?Math.min(active+1,visible.length-1):active<0?visible.length-1:Math.max(0,active-1));}else if(e.key==='Enter'&&!menu.hidden){e.preventDefault();if(active>=0)choose(visible[active]);else{const match=visible.find(o=>o.label.toLocaleLowerCase()===input.value.trim().toLocaleLowerCase());if(match)choose(match);}}else if(e.key==='Escape'){e.preventDefault();choose(options.find(o=>o.value===select.value)||options[0]);}else if(e.key==='Tab')close();});
    input.addEventListener('blur',()=>{const match=options.find(o=>o.label.toLocaleLowerCase()===input.value.trim().toLocaleLowerCase());if(match)choose(match);close();});toggle.addEventListener('pointerdown',e=>e.preventDefault());toggle.addEventListener('click',()=>{if(!menu.hidden)close();else{input.focus();query='';render();}});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
